/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeasurementPrinciple = {
    NotSpecified: 'NotSpecified',
    Summation: 'Summation',
    Phase: 'Phase',
} as const;
export type MeasurementPrinciple = typeof MeasurementPrinciple[keyof typeof MeasurementPrinciple];

